import React from "react";
import { useNavigate } from "react-router-dom";
import {
  SGridHeaderContainer,
  SHeaderTitle,
  SButtonsContainer,
  STrashCanIcon,
  STrashCanButton,
} from "./styles";
import {
  useAllPortfolios,
  useCurrentPortfolio,
  useCurrentPortfolioId,
} from "../../../../store";
import { PortfoliosButton } from "../../PortfoliosSelector/PortfoliosButton/PortfoliosButton";
import { generatePortfolioColor } from "../../../../utils";

export const Header: React.FC = () => {
  const navigate = useNavigate();
  const { selectedPortfolio, removeCurrentPortfolio, isLastPortfolio } =
    useCurrentPortfolio();
  const [currentPortfolioId] = useCurrentPortfolioId();
  const { allPortfolios } = useAllPortfolios();

  // TODO: if badge does not come back by the time 'fase3' ends, cleanup this
  //       code
  // const assetsQuantity =
  //   (selectedPortfolio && Object.keys(selectedPortfolio.assets).length) || 0;

  // const handleEditPortfolio = (): void => {
  //   navigate("../", { replace: true });
  // };

  const handleRemovePortfolio = (): void => {
    if (isLastPortfolio) {
      navigate("../");
    }
    removeCurrentPortfolio();
  };

  const detectBarColor = (): string =>
    generatePortfolioColor(Number(currentPortfolioId), allPortfolios);

  return (
    <SGridHeaderContainer>
      {/* <SBadgeContainer>
        <SBadge
          badgeContent={assetsQuantity}
          color="primary"
          overlap="circular"
          showZero
        >
          <DonutLargeIcon />
        </SBadge>
      </SBadgeContainer> */}
      <SHeaderTitle>
        {/* {selectedPortfolio?.name || t("portfolioEditorHeader")} */}
        <PortfoliosButton
          text={String(selectedPortfolio?.name)}
          barColor={detectBarColor()}
          id="0"
          chipMode
        />
      </SHeaderTitle>
      <SButtonsContainer>
        <STrashCanButton disableRipple onClick={handleRemovePortfolio}>
          <STrashCanIcon />
        </STrashCanButton>
        {/* <SLaunchIcon onClick={handleEditPortfolio} /> */}
      </SButtonsContainer>
    </SGridHeaderContainer>
  );
};
